import "./contact-details.scss";
import React from "react";
import { graphql, StaticQuery } from "gatsby";
import useTranslation from "locales";

import { numberWithoutSpaces } from "functions/numberWithoutSpaces";

const ContactDetails = ({
	contact,
	media,
	sponsors,
	phoneContact,
	data,
	lang,
}) => {
	const { t } = useTranslation(lang);
	const info = data.info.nodes[0].acfInformation.acfInformation;
	return (
		<div className="contact-details">
			{contact && (
				<div className="contact-details__content-container">
					<h3 className="contact-details__title">
						{t("Dane kontaktowe")}
					</h3>
					<address
						className="contact-details__address"
						dangerouslySetInnerHTML={{ __html: info.address }}
					/>
					{info.numberPl && (
						<div>
							{info.numberPl ? "PL: " : ""}
							<a
								href={`tel:${numberWithoutSpaces(
									info.numberPl
								)}`}
								className="contact-details__contact-link"
							>
								{info.numberPl}
							</a>
						</div>
					)}
					{info?.emailContact && (
						<div>
							<a
								href={`mailto:${info.emailContact}`}
								className="contact-details__contact-link"
							>
								{info.emailContact}
							</a>
						</div>
					)}
					<div className="contact-details__phone-container">
						{/* {t(
							"Automatyczna infolinia telefoniczna czynna przez całą dobę / 7 dni w tygodniu:"
						)} */}
						<a href="tel:+48459595777">+48 459 595 777</a>
						{/* <span className="contact-details__small">
							{t(
								"*Konsultanci telefoniczni są dostępni codziennie w godzinach 12:30-20:30. Opłata za połączenie jest zgodna z cennikiem Państwa operatora."
							)}
						</span> */}
					</div>
					<div className="contact-page__info">
						{t(
							"Pytania w sprawie Ogrodów Świateł, prosimy kierować na"
						)}
						:
						<a href="mailto:warszawa@ogrodswiatel.pl">
							warszawa@ogrodswiatel.pl
						</a>
						<a href="mailto:chorzow@ogrodswiatel.pl">
							chorzow@ogrodswiatel.pl
						</a>
						<a href="mailto:krakow@ogrodswiatel.pl">
							krakow@ogrodswiatel.pl
						</a>
						<a href="mailto:gdynia@ogrodswiatel.pl">
							gdynia@ogrodswiatel.pl
						</a>
					</div>
				</div>
			)}
			{media && (
				<div className="contact-details__content-container">
					<h3
						className="contact-details__title"
						dangerouslySetInnerHTML={{
							__html: t("Kontakt <br /> dla mediów"),
						}}
					/>
					<div>
						<a
							href={`tel:${numberWithoutSpaces(
								info.numberMedia
							)}`}
							className="contact-details__contact-link"
						>
							{info.numberMedia}
						</a>
					</div>
					<div>
						<a
							href={`mailto:${info.emailMedia}`}
							className="contact-details__contact-link"
						>
							{info.emailMedia}
						</a>
					</div>
				</div>
			)}
			{sponsors && (
				<div className="contact-details__content-container">
					<h3 className="contact-details__title">{t("Kontakt")}</h3>
					<div
						className="contact-details__m-b"
						dangerouslySetInnerHTML={{ __html: info.address }}
					/>
					{/* <div>
            PL:{" "}
            <a
              href="tel:+48797697601"
              className="contact-details__contact-link"
            >
              +48 797 697 601
            </a>
          </div>
          <div className="contact-details__m-b">
            EN:{" "}
            <a
              href="tel:+48786974150"
              className="contact-details__contact-link"
            >
              +48 786 974 150
            </a>
          </div> */}
					<div>
						<a
							href="mailto:kontakt@cd-lighting.pl"
							className="contact-details__contact-link"
						>
							kontakt@cd-lighting.pl
						</a>
					</div>
				</div>
			)}
			{phoneContact && (
				<div className="contact-details__content-container">
					<h3 className="contact-details__title">
						{t("Kontakt telefoniczny")}
					</h3>
					<div>
						<a
							href={`tel:${numberWithoutSpaces(info.numberPl)}`}
							className="contact-details__contact-link"
						>
							{info.numberPl}
						</a>
					</div>
					<div>
						<a
							href={`tel:${numberWithoutSpaces(info.numberEn)}`}
							className="contact-details__contact-link"
						>
							{info.numberEn}
						</a>
					</div>
					<div>
						<a
							href={`mailto:${info.emailCd}`}
							className="contact-details__contact-link contact-details__contact-link--email"
						>
							{info.emailCd}
						</a>
					</div>
				</div>
			)}
		</div>
	);
};

export default function ContactDetailsStatic(props) {
	return (
		<StaticQuery
			query={graphql`
				{
					info: allWp {
						nodes {
							acfInformation {
								acfInformation {
									address
									emailCareer
									emailContact
									emailMedia
									emailCd
									numberPl
									numberEn
									numberMedia
									numberSponsors
								}
							}
						}
					}
				}
			`}
			render={(data) => <ContactDetails data={data} {...props} />}
		/>
	);
}
